// extracted by mini-css-extract-plugin
export default {"Displays":"Displays_Displays__Gg9Ow","Displays_active":"Displays_Displays_active__FjYJ+"};